import { createLazyModuleLoader } from './lazyModuleLoader.js';
import { ensureModuleWithInit } from './moduleRuntimeHelpers.js';

export function createSettingsDomainRuntime(context = {}) {
  const {
    importWithChunkRecovery,
    state,
    elements,
    showToast
  } = context;

  let siteThemeModuleApi = null;
  let siteThemeModuleLoadingPromise = null;
  let siteThemeFullscreenModuleApi = null;
  let siteThemeFullscreenModuleLoadingPromise = null;

  const loadSiteThemeModule = createLazyModuleLoader({
    importWithChunkRecovery,
    importer: () => import('./siteThemeModule.js'),
    getApi: () => siteThemeModuleApi,
    setApi: (mod) => {
      siteThemeModuleApi = mod;
    },
    getLoadingPromise: () => siteThemeModuleLoadingPromise,
    setLoadingPromise: (promise) => {
      siteThemeModuleLoadingPromise = promise;
    }
  });

  const loadSiteThemeFullscreenModule = createLazyModuleLoader({
    importWithChunkRecovery,
    importer: () => import('./siteThemeFullscreenModule.js'),
    getApi: () => siteThemeFullscreenModuleApi,
    setApi: (mod) => {
      siteThemeFullscreenModuleApi = mod;
    },
    getLoadingPromise: () => siteThemeFullscreenModuleLoadingPromise,
    setLoadingPromise: (promise) => {
      siteThemeFullscreenModuleLoadingPromise = promise;
    }
  });

  function ensureSiteThemeModuleReady() {
    return ensureModuleWithInit(loadSiteThemeModule, {
      isInitializedExport: 'isSiteThemeModuleInitialized',
      initExport: 'initSiteThemeModule',
      createInitContext: () => ({
        state,
        elements
      })
    });
  }

  function ensureSiteThemeFullscreenModuleReady() {
    return ensureModuleWithInit(loadSiteThemeFullscreenModule, {
      isInitializedExport: 'isSiteThemeFullscreenModuleInitialized',
      initExport: 'initSiteThemeFullscreenModule',
      createInitContext: () => ({
        elements,
        showToast
      })
    });
  }

  return {
    ensureSiteThemeModuleReady,
    ensureSiteThemeFullscreenModuleReady,
    getSiteThemeModuleApi: () => siteThemeModuleApi,
    getSiteThemeFullscreenModuleApi: () => siteThemeFullscreenModuleApi
  };
}
